<template>
  <div>
    <page-header :title="$t('dictionary.endpoint')" />
    <page-body>
      <list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'EndpointIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'EndpointList',
    }
  },
}
</script>
